/**
 * The Sales flyout's pin (S4b; G0 moved it; C4b retired the fallback).
 *
 * Before G0 the pin lived in the quotes document (quotes.flyout.pinned) although it is a
 * setting of the shell's Sales section, not of Quotes. G0 moved it to shell.flyout.pinned and
 * read the quotes key as a fallback for one release. C4b drops the fallback (no prod user relied
 * on it): shell.flyout.pinned is the only source, read and written; the quotes sanitiser strips
 * a stored quotes.flyout, so it is never shown and never sent back. Every reader and writer (the
 * Sidebar, the palette's pin command, Quote preferences) goes through here, so they cannot
 * disagree.
 */
import { useCallback } from 'react';
import { usePreferences } from '../../contexts/PreferencesContext';

/** The pin from the shell document. */
export function pinnedFrom(shellDoc) {
  return !!(shellDoc && shellDoc.flyout && shellDoc.flyout.pinned === true);
}

export function useSalesPin() {
  const { doc: shellDoc, update: updateShell } = usePreferences('shell');
  const setPinned = useCallback(
    (pinned) => updateShell((d) => ({ ...d, flyout: { ...(d.flyout || {}), pinned } })),
    [updateShell]
  );
  return { pinned: pinnedFrom(shellDoc), setPinned };
}
